var _rect, _style, _text, _text2, _text3, _text4, _text5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 620,
    height: 780,
    viewBox: "0 0 620 780",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text{font-family:\"Noto Serif Georgian\",\"Noto Sans Georgian\",Georgia,serif; font-weight:800; fill:#000; letter-spacing:-1px;} .small{font-weight:700;}")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 310,
    y: 85,
    fontSize: 64,
    textAnchor: "middle",
    transform: "rotate(-3 310 85)"
  }, "\u10E0\u10DD\u10D2\u10DD\u10E0")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 310,
    y: 220,
    fontSize: 74,
    textAnchor: "middle",
    transform: "rotate(1 310 220)"
  }, "\u10D8\u10DE\u10DD\u10D5\u10D0")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 310,
    y: 350,
    fontSize: 58,
    textAnchor: "middle",
    transform: "rotate(-2 310 350)"
  }, "\u10D9\u10D0\u10DE\u10D8\u10E2\u10D0\u10DC\u10DB\u10D0")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 310,
    y: 500,
    fontSize: 78,
    textAnchor: "middle",
    transform: "rotate(2 310 500)"
  }, "\u10DC\u10D0\u10DB\u10D3\u10D5\u10D8\u10DA\u10D8")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 310,
    y: 655,
    fontSize: 70,
    textAnchor: "middle",
    transform: "rotate(-1 310 655)"
  }, "\u10D2\u10D0\u10DC\u10EB\u10D8")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage1);
export default __webpack_public_path__ + "static/media/page1.88d19ebc7f51775ab54062f6b9be6fd7.svg";
export { ForwardRef as ReactComponent };